import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AccessibilityEnhancements() {
  const { pathname } = useLocation();

  useEffect(() => {
    const target = document.querySelector("main") || document.querySelector("header ~ section") || document.querySelector("section");
    if (!target) return undefined;

    const assignedId = !target.id;
    if (assignedId) target.id = "msc-main-content";
    const assignedRole = target.tagName !== "MAIN" && !target.hasAttribute("role");
    if (assignedRole) target.setAttribute("role", "main");

    const skip = document.createElement("a");
    skip.className = "msc-skip-link notranslate";
    skip.href = `#${target.id}`;
    skip.translate = false;
    skip.textContent = window.localStorage.getItem("mysitecare-language") === "tl" ? "Lumaktaw sa pangunahing nilalaman" : "Skip to main content";
    document.body.insertBefore(skip, document.body.firstChild);

    return () => {
      skip.remove();
      if (assignedId) target.removeAttribute("id");
      if (assignedRole) target.removeAttribute("role");
    };
  }, [pathname]);

  return null;
}
